module.exports = __webpack_public_path__ + "static/media/worldIcon.37392af8.svg";